<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-progress-linear :indeterminate="true" v-if="isLoading"></v-progress-linear>
        <h1>Processing</h1>
        <v-select
          data-cy="FormFactoryItem-brandId"
          item-text="name"
          item-value="id"
          filled
          :label="$$t('brandId')"
          :items="brands"
          v-model="localFactoryItem.brandId"
          @change="brandChanged"
        ></v-select>
        <v-text-field
          filled
          data-cy="FormFactoryItem-processingMass"
          :label="$$t('processingMass')"
          v-model="localFactoryItem.processingMass"
          type="number"
        />
        <v-text-field
          filled
          data-cy="FormFactoryItem-packSize"
          :label="$$t('packSize')"
          v-model="localFactoryItem.packSize"
          type="number"
        />
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormFactoryItem-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4"
            :loading="isLoading"
            data-cy="FormFactoryItem-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormFactoryItem',
  module: 'FactoryItem',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    FactoryItem: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localFactoryItem
      */
      localFactoryItem: {},
    };
  },
  computed: {
    ...mapState('brands', ['brands']),
    ...mapState('stockItems', ['stockItems']),
  },
  watch: {
    FactoryItem() {
      this.localFactoryItem = this.FactoryItem;
    },
  },
  created() {
    this.localFactoryItem = this.FactoryItem;
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_brands();
    this.isLoading = false;
  },
  methods: {
    ...mapActions('brands', ['LOAD_brands']),
    brandChanged(brandId) {
      const brand = this.brands.find((b) => b.id === brandId);
      console.log(brand);
      this.localFactoryItem.packType = brand.packType;
    },
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localFactoryItem);
        this.isLoading = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormFactoryItem example

'''js
<FormFactoryItem :FactoryItem="FactoryItem" />
'''
</docs>
